import React from 'react'
import Conditional from '../common/Conditional'
import HtmlTooltip from '../common/HtmlTooltip'
import Tooltip from '../common/Tooltip'
import './FWOLabel.css'

export interface IFWOLabelProps {
  name: string
  label: string
  tooltip?: string
  htmlTooltip?: string
  defaultHtmlTooltipIconText?: string
  showOptional?: boolean
  title?: string
  required?: boolean
}

const FWOLabel = (props: IFWOLabelProps) => {
  return (
    <label id={`${props.name}lbl`}>
      {props.label}
      {props.showOptional && ' (optional)'}
      <Conditional if={props.tooltip?.length > 0}>
        <Tooltip>{props.tooltip}</Tooltip>
      </Conditional>
      <Conditional if={props.htmlTooltip?.length > 0}>
        <HtmlTooltip
          html={props.htmlTooltip}
          defaultIconText={props.defaultHtmlTooltipIconText}
        ></HtmlTooltip>
      </Conditional>
      {props.required && <span className="sr-only">(required)</span>}
    </label>
  )
}

export default FWOLabel
